export default __webpack_public_path__ + "static/media/330_dummy2016-eventagentur01-de-mobile.656729d2.png";